const rEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function InjuredValidations(values: any) {
  let errors: any = {};

  if (!rEmail.test(values.email)) {
    errors.email = "El email ingresado es inválido";
  }

  if (!/^\d+$/.test(values.phone_number)) {
    errors.phone = "Solo debes incluir números";
  }

  if (values.phone_number.length > 8) {
    errors.phone = "Máximo 8 números";
  }

  if (
    values.identification_number &&
    values.identification_number.length > 15
  ) {
    errors.identification_number = "El número de identificación es inválido";
  }

  if (
    values.identification_number &&
    !/^\d+$/.test(values.identification_number)
  ) {
    errors.identification_number = "Solo debes incluir números";
  }

  if (values.identification_number && values.identification_number[0] === "0") {
    errors.identification_number =
      "No incluyas el 0 al inicio de tu número de documento";
  }

  // const phoneNumber = parsePhoneNumberFromString(
  //   values.phone_number,
  //   "AR"
  // );

  // if (!phoneNumber?.isValid()) {
  //   errors.phone_number = "El número telefónico ingresado es inválido";
  // }

  return errors;
}
